
import { mapGetters } from 'vuex';
import AUTH from '@/constants/authority-codes';
export default {
  data () {
    return {
      $global_formOpts: {
        labelWidth: {
          normal: '108px'
        }
      }
    }
  },
  methods: {
    $_global_resetForm (form) {
      this.$refs[form].resetFields();
    },
    $hasAuthority (code) {
      return this.$store.getters.hasAuthority(code);
    },
    $hasAnyAuthority (codes) {
      return this.$store.getters.hasAnyAuthority(codes);
    },
    $hasAllAuthority (codes) {
      return this.$store.getters.hasAllAuthority(codes);
    }
  },
  computed: {
    ...mapGetters(['authority']),
    AUTH () {
      return AUTH;
    }
  }
};
